import { render, staticRenderFns } from "./passwordQuestion.vue?vue&type=template&id=2596d963&scoped=true"
import script from "./passwordQuestion.vue?vue&type=script&lang=js"
export * from "./passwordQuestion.vue?vue&type=script&lang=js"
import style0 from "./passwordQuestion.vue?vue&type=style&index=0&id=2596d963&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596d963",
  null
  
)

export default component.exports